import {SnSButton} from "./SnSButton.js";
import {collectGtm, isWebView} from "../../store";
import {mobileOpenSocialSignUpPopup} from "../../../../bridge/renewal-signup/index.js";
export class GoogleButton extends SnSButton {
    setup() {
        this.$props.isRender = !!window.googleApiAvailable
    }

    getButtonDataJson() {
        const { id = 'googleLoginButton'} = this.$props;
        return  {
            snsType: "google",
            id ,
            className : `login-google`,
            buttonText : i18next.t(login.googlestrt),
        }
    }

    setEvent() {
        const {id, snsType } = this.getButtonDataJson();
        const GoogleLogin = Mutil.requireIIFE("GoogleLogin");
        this.addEvent("click.prevent", `#${id}`, (e) => {
            const UserTracker = UserTracker || requireModule('userTracker', {on: ['signup']})();
            UserTracker?.SignUpTracker()?.track("google-sign-up");

            if(isWebView()) {
                mobileOpenSocialSignUpPopup( {appName : snsType.toUpperCase()});
                return
            }

            GoogleLogin.clickGoogleLoginButton(e);
        });
    }
}
